<template>
  <div class="search-container" style="max-width: 45vw" @click="onClickedOnContainer">
    <b-loading
        v-model="isLoading"
        :can-cancel="true"
        :is-full-page="true"
    ></b-loading>
    <div class="box m-0 p-0" style="border-radius: 8px">
      <b-field>
        <b-input placeholder="Search for site..."
                 ref="search"
                 v-model="searchText"
                 @input="onSearchTextChanged"
                 type="search"
                 style="width: 45vw"
                 @focus="onFocus"
                 @blur="onBlur"
                 icon="magnify"
                 custom-class="search-field">
        </b-input>
      </b-field>
    </div>
    <transition name="fade">
      <div v-if="showResults" class="box mt-2 is-flex is-flex-direction-column" style="height: 100%; padding: 12px">
        <h6 class="mt-4 ml-1 is-size-7 has-text-grey-light">RESULTS</h6>
        <hr class="m-0 ml-1 p-0">
        <div style="height: calc(100vh - 120px - 300px); overflow-y: auto; padding: 12px 4px 8px 4px;">
          <div>
            <div class="box search-box" v-for="site in filteredSites"
                 :class="{'selected' : selectedSite && selectedSite._id === site._id}"
                 :key="site._id" @click="toggleSelectedSite(site)">
              <div class="is-flex">
                <div>
                  <div class="ml-1">{{ site.name }}</div>
                  <div class="ml-1 has-text-weight-semibold" style="font-size: 14px">{{ site.clientSiteCodes ? site.clientSiteCodes.toString() : '' }}</div>
                </div>

                <div class="ml-auto is-flex is-align-items-center">
                  <div class="has-background-danger badge-search">{{site.new}}</div>
                  <div class="has-background-grey badge-search ml-1">{{site.responded}}</div>
                  <div class="has-background-primary badge-search ml-1">{{site.submitted}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import MyButton from "@/components/my-button/my-button.vue";
export default {
  name: "search-box-per-site",
  components: {},
  data() {
    return {
      searchText: '',
      isLoading: false,
      showResults: false
    }
  },
  async mounted() {},
  methods: {
    ...mapActions({
      setSelectedQuerySite: 'dtpQueryModule/setSelectedQuerySite',
      setQueryDataSites: 'dtpQueryModule/setQueryDataSites'
    }),
    onClickedOutside() {
      console.log('On clicked outside')
      this.showResults = false
    },
    onClickedOnContainer(){
      this.$emit('onClickedArea')
    },
    async toggleSelectedSite(site) {
      console.log('Selected project: toggle', site)
      if (this.selectedSite && this.selectedSite._id === site._id) {
        this.$emit('onToggleSelectedSite', null)
      } else {
        this.$emit('onToggleSelectedSite', site)
        console.log('Emit toggle')
      }
      this.showResults = true
    },
    onFocus() {
      console.log('On search focus')
      this.showResults = true
    },
    onBlur() {
      console.log('On search blur')
    },
    onSearchTextChanged(value) {
      console.log('On search text changed: ', value)
      let queryData = this.queryData
      queryData.query = value
      this.setQueryDataSites(queryData)
    }
  },
  computed: {
    ...mapGetters({
      allProjects: 'dtpQueryModule/getByProjects',
      selectedSite: 'dtpQueryModule/getSelectedQuerySite',
      queryData: 'dtpQueryModule/getQueryDataSites',
      filteredSites: 'dtpQueryModule/getFilteredQuerySites'
    }),
  },
}
</script>

<style lang="scss" scoped>
.search-container {
  top: 0;
  left: 0;
  bottom: 0;
  height: calc(100vh - 300px);
  display: flex;
  position: absolute;
  margin: 110px auto auto 16px;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 16px !important;
  z-index: 30;
  transition: all 0.3s linear;
}

.search-box {
  cursor: pointer;
  background-color: #00000008;
  border-radius: 6px;
  box-shadow: none;
  color: hsl(0deg, 0%, 29%);
  display: block;
  padding: 8px;
  margin-bottom: 8px;
}
.search-box:hover {
  background-color: #00000010;
}

.selected {
  background-color: rgba(0, 0, 0, 0.05);
}

.badge-search {
  padding-left: 6px;
  padding-right: 6px;
  max-height: 16px;
  font-size: 14px;
  border-radius: 4px;
  color: white;
  margin-top: 4px;
  line-height: 1;
  font-weight: 500;
  padding-top: 1px;
}
</style>